<template>
	<div class="group-box">
		<div class="title">选择登录分组 <i v-if="pageType == 'change'" class="iconfont icon-guanbi" @click="handleClose"></i>
		</div>
		<div class="group-list" v-loading="loading">
			<div class="group" v-for="(item,index) in groupList" :key="index">
				<div class="gruop-title">{{item.groupName}}</div>
				<ul class="group-ul">
					<li class="group-li" :class="{'select-li':selectId == sitem.id}"
						v-for="(sitem,sindex) in item.children" :key="sitem.id"
						@click="handleSelect(sitem.id,sitem.groupName)">
						{{sitem.groupName}} <i class="iconfont icon-duihao" v-if="selectId == sitem.id"></i>
					</li>
				</ul>
			</div>
		</div>
		<div class="submit-box">
			<div class="btn" :loading="btnLoading" @click="handleSubmit">确定</div>
		</div>
	</div>
</template>

<script>
	import {
		getGroupTree,
		salesmanGroup
	} from '@/api/user.js'

	import {
		setUserInfo,
	} from '@/utils/auth'

	import {
		mapGetters
	} from 'vuex';

	export default {
		props: {
			pageType: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				groupList: [],
				selectId: [],
				groupName: '',
				loading: false,
				btnLoading: false
			}
		},
		computed: {
			...mapGetters(['userInfo']),
		},
		created() {
			if (this.userInfo.groupId) this.selectId = this.userInfo.groupId
			if (this.userInfo.groupName) this.groupName = this.userInfo.groupName
			this.getGroupList()
		},
		methods: {
			getGroupList() {
				this.loading = true
				getGroupTree().then(res => {
					this.loading = false
					if (res?.code == 0 && res?.data?.length) {
						this.groupList = res.data
						if (!this.userInfo.groupId && !this.userInfo.groupName) {
							this.selectId = res.data[0].children[0].id
							this.groupName = res.data[0].children[0].groupName
						}
					}
				})
			},
			handleSelect(id, groupName) {
				this.selectId = this.selectId == id ? '' : id
				this.groupName = this.selectId == '' ? '' : groupName
			},
			handleSubmit() {
				if (this.selectId == '') {
					this.$message('请选择登录分组');
					return
				}
				this.btnLoading = true
				salesmanGroup(this.selectId).then(res => {
					this.btnLoading = false
					if (res?.code == 0) {
						this.$message({
							message: this.pageType == 'change' ? '切换成功！' : '提交成功！',
							type: 'success'
						});
						let userObj = {
							...this.userInfo,
							groupId: this.selectId,
							groupName: this.groupName
						}
						setUserInfo(userObj)
						this.$store.commit('SET_USERINFO', userObj);
						if (this.pageType == 'change') {
							this.handleClose()
						} else {
							setTimeout(() => {
								this.$router.replace('/home');
							}, 1000)
						}
					} else {
						this.$message.error(res.msg ? res.msg : '数据加载失败...');
					}
				})
			},
			handleClose() {
				this.$emit('handleClose')
			}
		},
	}
</script>

<style lang="scss" scoped>
	.group-box {
		width: 683px;
		height: 580px;
		background: #FFFFFF;
		border-radius: 16px;
		display: flex;
		flex-direction: column;

		.title {
			width: 679px;
			height: 72px;
			line-height: 72px;
			background: #F5F7FA;
			border-radius: 16px 16px 0 0;
			font-weight: bold;
			font-size: 24px;
			color: #262728;
			padding: 0 24px;
			box-sizing: border-box;
			margin: 2px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.iconfont {
				font-size: 25px;
				cursor: pointer;
			}
		}

		.group-list {
			width: 100%;
			box-sizing: border-box;
			padding: 0 24px;
			flex: 1;
			overflow-y: scroll;
			padding-top: 12px;

			.group {
				width: 100%;
				margin-top: 8px;

				.gruop-title {
					font-weight: bold;
					font-size: 20px;
					color: #262728;
				}

				.group-ul {
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					margin-top: 10px;

					.group-li {
						width: calc(33.33% - 8px);
						height: 48px;
						border-radius: 10px;
						border: 1px solid #EDEFF2;
						margin-right: 12px;
						margin-bottom: 12px;
						font-size: 14px;
						color: #262728;
						line-height: 48px;
						text-align: center;
						box-sizing: border-box;
						cursor: pointer;
					}

					.group-li:nth-child(3n) {
						margin-right: 0;
					}

					.select-li {
						background: #FFF9E0;
						border: 1px solid #FECE36;
						position: relative;

						.iconfont {
							width: 20px;
							height: 20px;
							line-height: 20px;
							text-align: center;
							background: #FFCC00;
							border-radius: 10px 0px 10px 0px;
							font-size: 9px;
							color: #262728;
							position: absolute;
							right: 0;
							bottom: 0;
						}
					}
				}
			}

		}

		.submit-box {
			width: 100%;
			height: 96px;

			.btn {
				width: 280px;
				height: 48px;
				line-height: 48px;
				text-align: center;
				background: #FFCC00;
				border-radius: 10px;
				font-weight: bold;
				font-size: 18px;
				color: #262728;
				margin: 24px auto;
				cursor: pointer;
			}
		}
	}
</style>